<script setup lang="ts">
import { onBeforeMount, ref, Ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useApiClient } from "@/api/client";
import ExportScheduleDO = App.Data.ExportScheduler.ExportScheduleDO;
import MainBreadcrumbs from "@/ui/components/header/MainBreadcrumbs.vue";

const exportSchedule: Ref<ExportScheduleDO> = ref();

const schedule_uuid: string | null =
	useRoute().params.schedule_uuid !== ""
		? String(useRoute().params.schedule_uuid)
		: null;

const getExportSchedule = async () => {
	const response = await useApiClient("exportSchedules").show(schedule_uuid);
	if (response.isOk()) {
		exportSchedule.value = response.value;
	}
};

onBeforeMount(() => {
	getExportSchedule();
});

const computedBreadcrumbs = computed(() => {
	if (exportSchedule.value) {
		return [
			{
				title: "Export Scheduler",
				disabled: false,
				to: "/scheduler",
			},
			{
				title: exportSchedule.value.title,
				disabled: true,
				to: "/scheduler",
			},
		];
	}
	return [];
});

const tabs = computed(() => {
	if (exportSchedule.value) {
		return [
			{
				translationKey: "scheduler.sections.configuration",
				icon: "fa-flask-gear",
				to: `/scheduler/${exportSchedule.value.uuid}/configuration`,
				visible: true,
			},
			{
				translationKey: "scheduler.sections.recipients",
				icon: "fa-envelope-dot",
				to: `/scheduler/${exportSchedule.value.uuid}/recipients`,
				visible: exportSchedule.value.export_type.delivery_channel === "email",
			},
			{
				translationKey: "scheduler.sections.history",
				icon: "fa-list-timeline",
				to: `/scheduler/${exportSchedule.value.uuid}/history`,
				visible: true,
			},
		].filter((tab) => tab.visible);
	}
	return [];
});

const activeTab = ref(null);
</script>

<template>
	<main-breadcrumbs
		v-if="computedBreadcrumbs.length > 0"
		:breadcrumbs="computedBreadcrumbs"
	/>
	<v-card elevation="4">
		<v-tabs v-model="activeTab" class="rounded-md">
			<v-tab
				v-for="tab in tabs"
				:key="tab.translationKey"
				:value="tab.translationKey"
				:to="tab.to"
			>
				<i :class="`fa-duotone ${tab.icon} fa-lg`"></i>
				<div class="tab-text">
					{{ $t(tab.translationKey) }}
				</div>
			</v-tab>
		</v-tabs>
		<router-view v-if="exportSchedule" :exportSchedule="exportSchedule" />
	</v-card>
</template>

<style scoped lang="scss"></style>
